import { CheckIcon } from "@heroicons/react/24/outline";

import { DropdownMenuItem } from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import { ReportReviewerStatus } from "@api/graphql/types-and-hooks";
import { useCanApprove } from "@components/ReportReview/hooks/useCanReviewReport";
import { useFinalApproverWaitReason } from "@components/ReportReview/hooks/useFinalApproverWaitReason";
import { useOpenFinishReview } from "@components/ReportReview/hooks/useFinishReview";

export const ApproveMenuItem: React.FC = () => {
  const openFinishReview = useOpenFinishReview();
  const canApprove = useCanApprove();
  const waitReason = useFinalApproverWaitReason();

  return (
    <DropdownMenuItem
      disabled={!canApprove || !!waitReason || !openFinishReview}
      onClick={() => openFinishReview?.(ReportReviewerStatus.Approved)}
    >
      <CheckIcon />
      Approve
    </DropdownMenuItem>
  );
};
